import { useQuery } from 'react-query';
import { getSession } from '../api/getSession';

const useSession = () => {
  const initial = JSON.parse(localStorage.getItem('DQPN_AUTH') || '{}');
  const staletime = initial?.userObject?.created_at ? 50000 : 500;
  const result = useQuery('sessions', () => getSession(), {
    refetchOnWindowFocus: true,
    staleTime: staletime,
  });
  return result;
};

export default useSession;
